import React from 'react';
import { bool, shape, string } from 'prop-types';

const SoilSampler = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M18 4H13V11H15V22H9V11H11V4H6V2H18V4ZM11 20H13V13H11V20Z" fill="currentColor" />
  </svg>
);

SoilSampler.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default SoilSampler;
